import { render, staticRenderFns } from "./PatientMeasurementNote.vue?vue&type=template&id=4518cd46&scoped=true&"
import script from "./PatientMeasurementNote.vue?vue&type=script&lang=js&"
export * from "./PatientMeasurementNote.vue?vue&type=script&lang=js&"
import style0 from "./PatientMeasurementNote.vue?vue&type=style&index=0&id=4518cd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518cd46",
  null
  
)

export default component.exports